module.exports = __webpack_public_path__ + "static/img/Group206.105aef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy/payment/Group206.png
// module id = iAo3
// module chunks = 150